import { useQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import { getChatMessages } from "@/api/chats";

export const useChatMessages = (chatId: number | null) => {
  return useQuery({
    queryKey: [ChatsQueryKeys.ChatMessages, chatId],
    queryFn: ({ signal }) =>
      getChatMessages({ signal, params: { chatId: chatId as number } }),
    enabled: Boolean(chatId),
  });
};
